import visaIcon from '@/assets/icons/payments/visa.svg';
import mastercardIcon from '@/assets/icons/payments/mastercard.svg';
import amexIcon from '@/assets/icons/payments/amex.svg';
import discoverIcon from '@/assets/icons/payments/discover.svg';

const CARD_BRANDS = [
  { name: 'Visa', icon: visaIcon },
  { name: 'Mastercard', icon: mastercardIcon },
  { name: 'Amex', icon: amexIcon },
  { name: 'Discover', icon: discoverIcon },
] as const;

export const CardBrandIcons = () => {
  return (
    <div className="absolute right-2 top-1/2 -translate-y-1/2 flex gap-1 pointer-events-none">
      {CARD_BRANDS.map((brand) => (
        <img key={brand.name} src={brand.icon} alt={brand.name} className="w-8 h-5 object-contain" />
      ))}
    </div>
  );
};
